import EventEmitter from 'tiny-emitter';
import isMobile from "ismobilejs";

class ScrollParallax extends EventEmitter
{
    constructor( container = null, scrollbar = null )
    {
      super()

      this.container = container
      this.scrollbar = scrollbar
      
      this.update = this.update.bind(this);
      this.animate = this.animate.bind(this);
      this.resize = this.resize.bind(this);
      this.unactive = this.unactive.bind(this);
      this.active = this.active.bind(this);
      // this.get = this.get.bind(this);
      // this.set = this.set.bind(this);
      // this.add = this.add.bind(this);
      this._elts = [];

      // if(isMobile.any)
      //   this._coef = 1
      // else
      //   this._coef = 0.05
    }


  static add(elt, def, before, after, limit, gap, options)
  {
    if( !elt ) return
    
    if (limit == null)
      limit = 2;
    if (gap == null)
      gap = 0;

      ScrollParallax.instance._elts.push({
      elt: elt,
      "default": ScrollParallax.getProp(def),
      before: ScrollParallax.getProp(before),
      after: ScrollParallax.getProp(after),
      limit: limit,
      gap: gap,
      options: options
    });
  }

  static set(elt, def, before, after, limit, gap, options)
  {
    if (limit == null)
      limit = 2;
    if (gap == null)
      gap = 0;

    let d = ScrollParallax.get(elt);
    if (d)
    {
      d["default"] = ScrollParallax.getProp(def);
      d.before = ScrollParallax.getProp(before);
      d.after = ScrollParallax.getProp(after);
      d.limit = limit;
      d.gap = gap;
      d.options = options
    }
    else
    {
      ScrollParallax.add(elt, def, before, after, limit, gap, options);
    }
    ScrollParallax.instance.update();
  }

  static remove( elt )
  {
    let elts = ScrollParallax.instance._elts;
    for (let i = 0; i < elts.length; i++)
    {
      if (elts[i].elt === elt)
        ScrollParallax.instance._elts.splice( i, 1 )
    }
  }

  static get(elt)
  {
    let ref = ScrollParallax.instance._elts;
    let len = ref.length;
    let r = null;
    for (let i = 0; i < len; i++) {
      r = ref[i];
      if (r.elt === elt) {
        return r;
      }
    }
    return null;
  }

  static getProp(obj)
  {
    let props = ['x', 'y', 'opacity', 'rotate'];
    let len = props.length;
    let p = null;
    for (let i = 0; i < len; i++) {
      p = props[i];
      if (obj[p] == null) {
        if (p !== 'opacity') {
          obj[p] = 0;
        }
      }
    }
    return obj;
  }

  active()
  {

    if (this._isActive) {
      return;
    }
    this._isActive = true;
    this.scrollY = 0;
    this.resize();
    this.update(this._coef, true);
    return this.requestId = window.requestAnimationFrame(this.animate);
  }

  unactive()
  {
    if (!this._isActive) {
      return;
    }
    this._isActive = false;
    if (this.requestId != null) {
      return window.cancelAnimationFrame(this.requestId);
    }
  }

  resize()
  {
    let ref = this._elts;
    let results = [];
    let len = ref.length;
    let r = null;
    for (let i = 0; i < len; i++) {
      r = ref[i];
      try{
        r.top = r.elt.getBoundingClientRect().top;
      } catch(e){ r.top = r.elt.offsetTop }
      
      results.push(r.height = r.elt.offsetHeight);
    }
    return results;
  }

  animate()
  {
    // console.log('animate', this)
    // this.update(1);
    this.update(this._coef);
    return this.requestId = window.requestAnimationFrame(this.animate);
  }

  update(coeff, forceUpdate = false)
  {
    this.wh = window.innerHeight;

    var d, el, i, len, p, pA, pAOld, prc, r, ref, results, s, so, sr, stop, sx, sy, tr, x, y;
    if (coeff == null) {
      coeff = 1;
    }

    // console.log( coeff )

    s = window.pageYOffset;
    if( this.container )
    {
      try{
        s = this.container.getBoundingClientRect().top
      } catch(e){ s = this.container.offsetTop }
    }

    if( this.scrollbar )
    {
      s = -this.scrollbar.offset.y
    }

    // console.log( this.scrollbar )

    this.scrollTop = s;
    stop = false;
    if (Math.abs(this.scrollTop - this.scrollY) >= .02 || forceUpdate ) {
      this.scrollY += (this.scrollTop - this.scrollY) * coeff;
    } else {
      return;
    }

    let cf = this.scrollTop - this.scrollY
    ref = this._elts;
    results = []; 
    var dep;
    // console.log( ref );
    for (i = 0, len = ref.length; i < len; i++)
    {
      r = ref[i];
      el = r.elt; 

      dep = el
      if( r.options && r.options.depend != null )
      {
        dep = r.options.depend;
      }

      let top = null
      try{
        top = dep.getBoundingClientRect().top
      } catch(e){ top = dep.offsetTop }

      p = 1 - ( ( ( top + dep.offsetHeight / 2 ) + cf ) / window.innerHeight ) * 2;
      // console.log( (el.getBoundingClientRect().top + el.offsetHeight / 2 )+' / '+window.innerHeight );
      p += r.gap;
      pA = Math.max(0, Math.min(r.limit, Math.abs(p)));
      d = r.before;
      if (p > 0) {
        d = r.after;
      }
      pAOld = pA;
      prc = 0;
      if (d.prc != null) {
        prc = d.prc;
      }
      pA = Math.max(0, (pA - prc) / (1 - prc));
      x = d.x;
      y = d.y;
      if (typeof x === "string" && dep.parentNode) { 
        x = (parseInt(x) / 100) * dep.parentNode.offsetWidth;
      }
      if (typeof y === "string" && dep.parentNode) {
        y = (parseInt(y) / 100) * dep.parentNode.offsetHeight;
      }

      // console.log( p );

      // console.log( el.parentNode.offsetWidth+' / '+el.parentNode.offsetHeight )
      sx = pA * (x - r["default"].x) + r["default"].x;
      sy = pA * (y - r["default"].y) + r["default"].y;

      // console.log( p+' / '+pA+' / '+y+' / '+r["default"].y, d );
      sr = pA * (d.rotate - r["default"].rotate) + r["default"].rotate;
      so = Math.max(0, pA * (d.opacity - r["default"].opacity) + r["default"].opacity);
      tr = "translate3d( " + Math.round(sx) + "px, " + Math.round(sy) + "px, 0) rotate( " + sr + "deg )";
      el.style.webkitTransform = tr;
      el.style.MozTransform = tr;
      el.style.msTransform = tr;
      el.style.OTransform = tr;
      el.style.transform = tr;
      if (d.opacity != null) {
        el.style.opacity = so;
        results.push(el.style.filter = 'alpha(opacity=' + (so * 100) + ')');
      } else {
        results.push(void 0);
      }
    }

    this.emit( 'update', window.pageYOffset )
    return results;
  }

  emitUpdate()
  {
    this.emit( 'update', window.pageYOffset )
  }

  position(scrollTop)
  {
    this.scrollTop = scrollTop;
    if (!this._isActive) {
      return;
    }
    this.wh = window.innerWidth;
    return this.scrollTop;
  }

  static init( container, scrollbar )
  {
    ScrollParallax.__instance = new ScrollParallax( container, scrollbar )
  }

  static get instance()
  {
    return ScrollParallax.__instance
  }
}

ScrollParallax.__instance = null

export default ScrollParallax;



// WEBPACK FOOTER //
// ./src/js/libs/ScrollParallax.js